"use client";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/shared/auth/hooks";

import { applyKeys } from "@/features/apply/queries/keys";

export function TrustBar() {
  const { isAuthenticated, apiClient } = useAuth();

  const userCount = useQuery({
    queryKey: applyKeys.userCount(),
    queryFn: () => apiClient.get<{ count: number }>("/users/count-users"),
    enabled: !isAuthenticated,
  });
  const brandCount = useQuery({
    queryKey: applyKeys.brandCount(),
    queryFn: () => apiClient.get<{ count: number }>("/brands/count-brands"),
    enabled: !isAuthenticated,
  });

  if (isAuthenticated) return null;

  const metrics = [
    {
      value: brandCount.data?.data?.count
        ? `${brandCount.data.data.count.toLocaleString()}+`
        : "500+",
      label: "입점 공급자",
    },
    { value: "23,000+", label: "누적 제품" },
    {
      value: userCount.data?.data?.count
        ? `${userCount.data.data.count.toLocaleString()}+`
        : "7,000+",
      label: "누적 고객",
    },
  ];

  return (
    <section className="border-y border-neutral-200 py-8 md:py-10">
      <div className="max-w-screen-xl mx-auto px-6 grid grid-cols-3 divide-x divide-neutral-200">
        {metrics.map((metric) => (
          <div key={metric.label} className="flex flex-col items-center gap-1 px-4">
            <span className="font-heading text-xl md:text-2xl font-semibold text-neutral-900 tracking-tight">
              {metric.value}
            </span>
            <span className="text-[11px] md:text-xs text-neutral-400 tracking-wide">
              {metric.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
